import React, { useEffect , useRef} from 'react'
import { Link } from 'react-router-dom'
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';
import { Helmet } from "react-helmet";
const Contactus = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const form = useRef();

    const notify = () => toast.success("successfully", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
    });
    


      const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_w49g7u8', 'template_u68s50g',form.current, 'I9LvHOGez5gm6MWw0')
          .then((result) => {
              console.log(result.text);
              notify();
              window.location.reload();
          }, (error) => {
              console.log(error.text);
          });
      
      };
    

    return (
        <>
  <Helmet>
        <title>Contact Page</title>
        <meta name="description" content="Information about admission in shinde institute of pharmacy and research , Required Documents" />
      </Helmet>

            <div className='background4'>
            <div className="row"> 

            <center>  <h1 className="text-white mt-4">Home {'>'} Contact us</h1>  </center>
            </div>
            </div>


            <section className="contactus-section  "  >

                <div className="container rounded margin-top-contact  card-5" style={{ background: "white" }} >

                    <div className="row" >
                        <div className="col-12 col-lg-10 mx-auto">
                            <div className="row ">
                                <div className="contact-leftside col-12 col-lg-5">
                                    <ul style={{ marginTop: "0.5rem" }}>
                                        <br />
                                        <h1 className="" style={{ textDecoration: "none" }}>Contact</h1>
                                        <br />

                                        <li style={{ textDecoration: "none", fontSize: "17px" }}> <i className="fa fa-phone-square" ></i> +919604982355/9137319282/9137319282</li><br />
                                        <li style={{ textDecoration: "none", fontSize: "17px" }}> <i className="fa fa-phone-square" ></i> Manoj Patil : +91 83800 48830</li><br />
                                        <li style={{ textDecoration: "none", fontSize: "17px" }} > <i className="fa fa-envelope"></i> Shindeinstitute@gmail.com</li><br />
                                        <li className="" style={{ textDecoration: "none", fontSize: "17px" }}><i className="fa fa-map-marker" ></i> Shinde international school in opposite<br /> of Vijaya bank Bhadgaon Road Pachora,<br /> Pachora,Maharashtra</li><br />
                                    </ul>
                                    <Link to="/"><i className="fa fa-instagram fa-3x zoom color text-dark" style={{ marginTop: "1.2rem", marginBottom: "1.2rem", paddingRight: "1.5rem", paddingLeft: "1.5rem" }}></i></Link>
                                    <Link to="/"><i className="fa fa-twitter-square fa-3x zoom   color text-dark" style={{ paddingRight: "1.5rem", paddingLeft: "1rem" }}></i></Link>
                                    <Link to="/"><i className="fa fa-facebook-square fa-3x zoom  color text-dark" style={{ paddingRight: "1.5rem", paddingLeft: "1rem" }}></i></Link>
                                    <Link to="/"><i className="fa fa-skype fa-3x zoom  color text-dark" style={{ paddingRight: "1.5rem", paddingLeft: "1.5rem" }}></i></Link>
                                </div>

                                {/* right side contact form  */}
                                <div className="contact-rightside col-12 col-lg-7">

                                    <center> <h1 style={{ marginBottom: "3rem", marginTop: "1rem" }}>Contact With our Team</h1></center>
                                     <form ref={form} onSubmit={sendEmail}>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 contact-input-feild" style={{ marginTop: "-3rem" }}>
                                                <p className="mt-3 mb-2" style={{ fontSize: "17px" }}>FullName:</p>
                                                <input
                                                    type="text"
                                                    name="user_name"
                                                    id=""
                                                    className="form-control"

                                                />
                                            </div>
                                            <div className="col-12 col-lg-6 contact-input-feild" style={{ marginTop: "-3rem" }}>
                                                <p className="mt-3 mb-2" style={{ fontSize: "17px" }}>PHONE NO:</p>
                                                <input
                                                    type="text"
                                                    name="user_phone"
                                                    id=""
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">

                                            <div className="col-12 col-lg-6 contact-input-feild" style={{ marginTop: "-4rem" }}>
                                                <p className="mt-3 mb-2" style={{ fontSize: "17px" }}>EMAIL:</p>
                                                <input
                                                    type="text"
                                                    name="user_email"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="col-12 col-lg-6 contact-input-feild" style={{ marginTop: "-4rem" }}>
                                                <p className="mt-3 mb-2" style={{ fontSize: "17px" }}>SUBJECT:</p>
                                                <input
                                                    type="text"
                                                    name="sub"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12  contact-input-feild " style={{ marginTop: "-2rem" }}>
                                                <p style={{ fontSize: "17px", marginLeft: "0px", marginBottom: "5px" }}>MASSAGE:</p>

                                                <textarea className='text_field contact_form_message card-6 ' id='' type="text" name="message" cols="30" rows="4" ></textarea>
                                            </div>
                                        </div>
                                        <div className="form-check form-checkbox-style " style={{ marginTop: "-1rem" }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="flexCheckChecked"
                                            />
                                            <label
                                                className=" form-check-label main-hero-para " style={{ marginTop: "-1.5rem" }} >
                                                I agree that the  Shinde Institute of Pharmacy and Research may contact me at the email address or phone number above
                                            </label>
                                        </div>

                                        <button
                                            style={{ marginTop: "1rem", fontSize: "18px" }}
                                            type="submit"
                                            value="Send"
                                            className="btn btn-dark w-100 mb-5 rounded ">
                                            Submit
                                        </button>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>

            <div className="container-fluid " >
                <p className="maps " ><iframe title='shinde institute of pharmacy and research' style={{ width: "100%", height: "27rem", border: "0", allowfullscreen: "", loading: "lazy" }} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8127.4139469632455!2d75.31350565026248!3d20.66281568510219!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd942c6504cdb69%3A0xfb9a214c508ffbc5!2sShinde%20International%20School!5e1!3m2!1sen!2sin!4v1660674634458!5m2!1sen!2sin" ></iframe></p>
            </div>

 
            <div className='row head2 footer-booknow margin-bottom' style={{ background: "rgb(77 135 25)", marginBottom: "-2.9rem" }} >

                <div className='col-lg-8 col-md-8 ' style={{ color: "white", marginTop: "1.2rem", marginBottom: "1.2rem" }} >
                    <center> <h3 className='small2'>Are you looking for Pharmacy <br></br> College ?</h3></center>

                </div>
                <div className='col-lg-4 col-md-4' style={{ color: "white", marginTop: "2.5rem" }}>
                    <center>  <h4 className='small3 '><i className="fa fa-phone-square" ></i> Call +91 83800 48830 or  <span>    <Link to="/" type="button" className="btn btn-outline-warning mx-1" >
                        Know more
                    </Link></span></h4></center>


                </div>
            </div>
        </>
    )
}

export default Contactus